/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Crumb } from 'cio/services/crumbs';

interface CioCrumbsArgs {
  crumbs: Crumb[];
}

export default class CioCrumbs extends Component<CioCrumbsArgs> {
  get lastCrumb() {
    return this.args.crumbs[this.args.crumbs.length - 1];
  }
}
